import { watchFetchOpenOrders } from './fetchOpenOrders';
import { watchFetchOrder } from './fetchOrder';

export const orderSagas = [watchFetchOpenOrders(), watchFetchOrder()];
